export default {
  name: 'timeline',
  components: {},
  props: ['crop', 'cultivationMethodNumber'],
  data () {
    return {
    }
  },
  computed: {
    monthWithAction () {
      var monthsWitAction = []
      const currentYear = this.moment().year()

      for (let step = 1; step <= parseInt(this.crop[`method${this.cultivationMethodNumber}_number_of_actions`]); step++) {
        var from = this.crop[`method${this.cultivationMethodNumber}action${step}_period_from`]
        var to = this.crop[`method${this.cultivationMethodNumber}action${step}_period_to`]
        var actionType = this.crop[`method${this.cultivationMethodNumber}action${step}_action_type`]
        if (from) {
          from = this.moment(from).year(currentYear)
          if (from.isBefore()) {
            from = this.moment(from).year(currentYear + 1)
          }
        }

        if (to) {
          to = this.moment(to).year(currentYear)
          if (to.isBefore(from)) {
            to = this.moment(to).year(from.year())
            if (to.isBefore(from)) {
              to = this.moment(to).year(from.year() + 1)
            }
          }
        }

        if (to && from && this.moment.isMoment(to) && this.moment.isMoment(from)) {
          if (to.year() !== from.year()) {
            monthsWitAction.push({
              from: from.format('L'),
              to: from.endOf('year').format('L'),
              step: step,
              type: actionType
            })
            to.year(from.year())
            monthsWitAction.push({
              from: this.moment('01/01/2000', 'DD/MM/YYYY').year(from.year()).format('L'),
              to: to.format('L'),
              step: step,
              type: actionType
            })
          } else {
            monthsWitAction.push({
              from: from.format('L'),
              to: to.format('L'),
              step: step,
              type: actionType
            })
          }
        } else {
          const amount = (this.crop[`method${this.cultivationMethodNumber}action${step}_period_number`] || 1)
          const period = this.crop[`method${this.cultivationMethodNumber}action${step}_period_period`]
          const action = this.crop[`method${this.cultivationMethodNumber}action${step}_period_action`]
          var relatedStep = monthsWitAction.filter(x => x.step == action)[0]
          monthsWitAction.push({
            from: this.moment(relatedStep.from, 'L').add(amount, period).format('L'),
            to: this.moment(relatedStep.to, 'L').add(amount, period).format('L'),
            step: step,
            type: actionType
          })
        }
      }
      return monthsWitAction
    }
  },
  mounted () {
  },
  methods: {
    periodClass (period, month, year = 0) {
      var classToAssign = 'grey'
      var startOfMonth = this.moment(`01/${month}/${this.moment().format('YY')}`, 'DD/M/YY')
      var middelOfMonth = this.moment(`10/${month}/${this.moment().format('YY')}`, 'DD/M/YY')
      var middelOfMonthLate = this.moment(`20/${month}/${this.moment().format('YY')}`, 'DD/M/YY')
      var endOfMotnh = this.moment(`01/${month}/${this.moment().format('YY')}`, 'DD/M/YY').endOf('month').startOf('day')

      var start
      var end
      switch (period) {
        case 1:
          start = startOfMonth
          end = middelOfMonth
          break
        case 2:
          start = middelOfMonth
          end = middelOfMonthLate
          break
        case 3:
          start = middelOfMonthLate
          end = endOfMotnh
          break
      }
      var matching = this.monthWithAction.filter(action => this.isInRange(start, action) && this.isInRange(end, action))

      if (matching.length) {
        const applySowColor = matching.some(action => action.step == 1)
        const applyHarvestColor = matching.some(action => action.step === parseInt(this.crop[`method${this.cultivationMethodNumber}_number_of_actions`]))
        if (applySowColor && applyHarvestColor) classToAssign = 'primary-secondary'
        else if (applySowColor) classToAssign = 'primary'
        else if (applyHarvestColor) classToAssign = 'secondary'
        else classToAssign += ' dot'
      }
      return classToAssign
    },
    isInRange (monthToCheck, range) {
      var from = this.moment(range.from, 'L').year(monthToCheck.year())
      var to = this.moment(range.to, 'L').year(monthToCheck.year())
      if (from.isSameOrAfter(to)) to.add(1, 'years')
      var isInRange = monthToCheck.isSameOrAfter(from) && monthToCheck.isSameOrBefore(to)
      return isInRange
    }
  }
}
